module.exports = "<i class=\"icon padding-right\" ng-class=\"{\n    'vehiclecheck-state-okay ion-arrow-up-a' : $ctrl.checkState == 'OKAY',\n    'vehiclecheck-state-marginal ion-arrow-right-a' : $ctrl.checkState == 'MARGINAL',\n    'vehiclecheck-state-risky ion-arrow-down-a' : $ctrl.checkState == 'RISKY'}\">\n</i>\n\n<span ng-if=\"::$ctrl.withLabel\" translate>\n    {{$ctrl.checkState}}\n</span>\n";


//////////////////
// WEBPACK FOOTER
// ./src/modules/main/components/vehiclecheck-state-icon/vehiclecheck-state-icon.html
// module id = 914
// module chunks = 0